import './RetryButton.css';

interface RetryButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function RetryButton({ onClick, disabled = false }: RetryButtonProps) {
  return (
    <button
      className="retry-button"
      onClick={onClick}
      disabled={disabled}
      type="button"
      aria-label="Retry message"
    >
      ↻ Retry
    </button>
  );
}
